import Entity from '@/entities/entity'

/*!
 * TemperatureAttachment实体
 */
export default class TemperatureAttachment extends Entity<number> {

    tenantId?: number

    client?: string

    doBatch?: string

    imageSource?: Blob
}